import { styled } from "@mui/material/styles";
import LogoGm from "src/images/gm-logo.png";
import GetStartedTitle from "./GetStartedTitle";
import Logo from "src/components/Logo";

const Wrapper = styled("header")(({ theme }) => ({
  top: 0,
  zIndex: 9,
  lineHeight: 0,
  width: "100%",
  display: "flex",
  alignItems: "center",
  position: "absolute",
  padding: theme.spacing(3),
  justifyContent: "space-between",
  [theme.breakpoints.up("md")]: {
    alignItems: "flex-start",
    padding: theme.spacing(7, 5, 0, 7),
  },
}));

const Header = () => (
  <Wrapper>
    {/* <img src={LogoGm} width={150} /> */}
    <Logo />
    <GetStartedTitle />
  </Wrapper>
);

export default Header;
